"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVGMenuSlice = function SVGMenuSlice(_ref) {
  var itemCount = _ref.itemCount,
      _ref$cutout = _ref.cutout,
      cutout = _ref$cutout === void 0 ? 0 : _ref$cutout;
  // Calculate the point of our slice on the unit circle.
  var circleX = Math.cos(Math.PI * 2 / itemCount);
  var circleY = Math.sin(Math.PI * 2 / itemCount); // Translate the unit circle to a [0,0];[1,1] square (top-left, bottom-right).

  var arcX = (circleX + 1) / 2;
  var arcY = (circleY - 1) / -2;
  var startX = 0.5 + 0.5 * cutout;
  var circleEndX = circleX * cutout;
  var circleEndY = circleY * cutout;
  var endX = (circleEndX + 1) / 2;
  var endY = (circleEndY - 1) / -2;
  return _react.default.createElement("svg", {
    height: "0",
    width: "0"
  }, _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    clipPathUnits: "objectBoundingBox",
    id: "sector"
  }, _react.default.createElement("path", {
    fill: "none",
    stroke: "#111",
    strokeWidth: "1",
    className: "sector",
    d: "M".concat(startX, ",0.5 L1,0.5 A0.5,0.5 0 0,0 ").concat(arcX, ",").concat(arcY, " L").concat(endX, ",").concat(endY, " A").concat(cutout / 2, ",").concat(cutout / 2, " 0 0,1 ").concat(startX, ",0.5")
  }))));
};

SVGMenuSlice.propTypes = {
  itemCount: _propTypes.default.number.isRequired,
  cutout: _propTypes.default.number
};
var _default = SVGMenuSlice;
exports.default = _default;